import { getAppInstance } from '@/utils/api/app';

export const checkUserExistsWithLogin = (email: string) => getAppInstance().post('/member-match', { email });

export const checkUserExistsNoAccount = (email: string) => getAppInstance().post('/member-match-no-account', { email });
